import React from 'react'
import Home from './pages/Home'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Footer from './pages/Footer';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/dashboard/Dashboard';
function App() {
  return (
    <div style={{width:'100vw',overflow:'hidden'}}>
     <BrowserRouter>
     <Routes>
      <Route path="/" element={<Home />} />
     <Route path="/login" element={<Login />} />
     <Route path="/dashboard" element={<Dashboard />} />  
    </Routes>
     <Footer/>
     </BrowserRouter>
    </div>
  )
}

export default App